import 'angular';

import { StockTakeCtrl }         from './stock-take';
import { StockTakeStates }       from './stock-take.states.ajs';

angular.module('workshop.stockTake', [
  'app-lite.stock-take'
])
.config(StockTakeStates)
.controller('StockTakeCtrl', StockTakeCtrl);